export default "__VITE_PUBLIC_ASSET__ec749d4b__"